import { axiosIns } from "../utils";

export const fetchVersionPolicy = async () => {
  const res = await axiosIns.get("/app-config/version-policy/");
  return res && res.data ? res.data : res;
};

export const updateVersionPolicyApi = async (payload) => {
  const res = await axiosIns.patch("/app-config/version-policy/", payload);
  return res && res.data ? res.data : res;
};
